var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScatterplotChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "72px",
    viewBox: "0 0 74 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2410DB41-E56E-49EE-B8CB-3EC76EF0C767") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.7088008,34.8387331 C5.5495952,34.8387331 7.04884848,36.3412885 7.04884848,38.182561 C7.04884848,40.0238335 5.5495952,41.5263889 3.7088008,41.5263889 C1.86800639,41.5263889 0.368753111,40.0238335 0.368753111,38.182561 C0.368753111,36.3412885 1.86800639,34.8387331 3.7088008,34.8387331 Z M21.3486782,17.9831435 C23.9270731,17.9831435 26.0260277,20.0844736 26.0260277,22.6641815 C26.0260277,25.2470999 23.9270731,27.3484301 21.3486782,27.3484301 C18.7702832,27.3484301 16.6713286,25.2470999 16.6713286,22.6641815 C16.6713286,20.0844736 18.7702832,17.9831435 21.3486782,17.9831435 Z M11.5931092,0.0552173466 C13.953431,0.0552173466 15.8695889,1.97514926 15.8695889,4.3365371 C15.8695889,6.69953023 13.950224,8.61785685 11.5931092,8.61785685 C9.23599445,8.61785685 7.31662955,6.69953023 7.31662955,4.3365371 C7.31662955,1.97514926 9.23278749,0.0552173466 11.5931092,0.0552173466 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0782194,37.7260201 C7.879498,37.7260201 10.1564388,40.0055379 10.1564388,42.8083816 C10.1564388,45.6112254 7.87789452,47.8923485 5.0782194,47.8923485 C2.27694081,47.8923485 -6.39488462e-13,45.6112254 -6.39488462e-13,42.8083816 C-6.39488462e-13,40.0055379 2.27694081,37.7260201 5.0782194,37.7260201 Z M20.1765819,24.081019 C25.2596117,24.081019 29.3965887,28.2210728 29.3965887,33.3114609 C29.3965887,38.4018489 25.2596117,42.5419028 20.1765819,42.5419028 C15.093552,42.5419028 10.9565751,38.4002437 10.9565751,33.3114609 C10.9565751,28.2226781 15.093552,24.081019 20.1765819,24.081019 Z M52.5139518,23.2783719 C55.8267404,23.2783719 58.5269998,25.9784768 58.5269998,29.2982253 C58.5269998,32.6147632 55.8267404,35.3180787 52.5139518,35.3180787 C49.2011633,35.3180787 46.5009039,32.6147632 46.5009039,29.2982253 C46.5009039,25.9816874 49.2011633,23.2783719 52.5139518,23.2783719 Z M40.7556371,15.9180977 C43.7765923,15.9180977 46.2347263,18.3790138 46.2347263,21.4033882 C46.2347263,24.4277625 43.7765923,26.8886786 40.7556371,26.8886786 C37.7346818,26.8886786 35.2765478,24.4277625 35.2765478,21.4033882 C35.2765478,18.3790138 37.7346818,15.9180977 40.7556371,15.9180977 Z M55.7209107,11.2354544 C58.741866,11.2354544 61.2,13.6963705 61.2,16.7207449 C61.2,19.7451192 58.741866,22.2060353 55.7209107,22.2060353 C52.6999555,22.2060353 50.2434249,19.7451192 50.2434249,16.7207449 C50.2434249,13.6963705 52.6999555,11.2354544 55.7209107,11.2354544 Z M41.6904656,-1.76648819e-14 C45.2277412,-1.76648819e-14 48.1043834,2.87989788 48.1043834,6.42117698 C48.1043834,9.96245609 45.2277412,12.842354 41.6904656,12.842354 C38.1531899,12.842354 35.2765478,9.96245609 35.2765478,6.42117698 C35.2765478,5.98453695 35.3214452,5.55913397 35.4032227,5.14175747 C35.4032227,5.13854688 35.4064296,5.13694159 35.4064296,5.133731 C36.002924,2.20727959 38.5925433,-1.76648819e-14 41.6904656,-1.76648819e-14 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.2-WebPageBuilder-EmptyWidgets",
    transform: "translate(-1120.000000, -322.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Scatter",
    transform: "translate(892.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Scatter-Chart/40dp",
    transform: "translate(228.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(21.600000, 20.911111)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-2)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.600000, -20.911111)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(5.400000, 10.800000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-4)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.400000, -10.800000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatterplotChart);
export default __webpack_public_path__ + "static/media/scatterplotChart.794bbc231814d37f3a4c76f96b185692.svg";
export { ForwardRef as ReactComponent };